const fadeInUp = (element) => {
  element.animate([
    { opacity: 0, transform: 'translateY(40px)' },
    { opacity: 1, transform: 'translateY(0)' }
  ], {
    duration: 200,
    delay: 1800,
    easing: 'ease-out',
    fill: 'forwards' // Keeps final state after animation
  });
};

document.addEventListener('DOMContentLoaded', () => {

  const observer = new MutationObserver((mutations, observer) => {

    const shopifyChatWidget = document.getElementById('ShopifyChat');
    const highestindex = '2147483647';
    
    if (shopifyChatWidget) {
      shopifyChatWidget.style.zIndex = `${highestindex - 2}`;
    }
    
    const container = document.querySelector('.Accessify_Container');
   
    if (container) {
      container.style.visibility = 'hidden'; 
      
      const shadow = container.shadowRoot;
      const root = document.documentElement;

      shadow.host.style.setProperty('--main-color-RgbValues', '#000000');

      const drawer = shadow.querySelector('.Accessify_Sidebar');
      const trigger = shadow.querySelector('.Accessify_Trigger_bottomLeft');
      const mediaQuery = window.matchMedia('(max-width: 768px)');
      
      if (trigger) {
        // Set an ID to apply styles with higher specificity
        trigger.id = 'accessifyTrigger';
        drawer.id = 'accessifyDrawer';
        const higherSpecificityTrigger = shadow.querySelector(`#${trigger.id}`);
        const higherSpecificityDrawer = shadow.querySelector(`#${drawer.id}`);

        // Shopify's chat widget has an absurdly high z-index we need to top
        higherSpecificityDrawer.style.cssText = `
          z-index: ${highestindex} !important;
          right: unset;
        `;
        
        higherSpecificityTrigger.style.cssText = `
          left: ${mediaQuery.matches ? '100px' : '150px'} !important;
          bottom: 20px !important;
          filter: drop-shadow(rgba(7, 7, 7, 0.18) 0px 0px 30px);
          box-shadow: initial !important;
          -webkit-box-shadow: initial !important;
          z-index: ${highestindex - 1} !important;
          width: 60px !important;
          height: 60px !important;
        `;
    
        const triggerSvg = higherSpecificityTrigger.querySelector('svg');
        if (triggerSvg) {
          triggerSvg.style.fill = '#000000';
        }

        container.style.visibility = 'visible';  
        observer.disconnect(); // Stop observing once the element is found and processed
      }
    }
  });
  
  // Start observing changes in the document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});